import React from 'react';
import './validationEsmaTable.scss';
import ReportingRegime from '../../../../infrastructure/types/common/ReportingRegime';

const createValidationEsmaTable = (tableRows?: string[][], onChange?: (e: any, rowIndex: number, cellIndex: number) => void): JSX.Element => {

    tableRows = tableRows || [[]];

    const headers = ['', 'NEWT', 'MODI', 'VALU', 'CORR', 'TERM', 'EROR', 'REVI', 'POSC', 'MARU'];

    return (
        <div id='validationsEsmaTable'>
            <div>
                <div key='headerRow' className='display-flex'>
                    {headers.map((header: string) => {
                        return <div className='header' key={header}>{header || ''}</div>
                    })
                    }
                </div>
            </div>
            <div className='tbody'>
                {tableRows.map((row: string[], rowIndex: number) => {
                    return <div key={rowIndex} className='tr' >
                        {row.map((value: string, cellIndex: number) => {
                            return <input disabled={cellIndex > 0 && !onChange} type="text" className='td input' key={cellIndex} onChange={(e: any) => onChange ? onChange(e, rowIndex, cellIndex) : null} value={value ?? ''} />
                        })
                        }
                    </div>
                })
                }
            </div>
        </div>
    )
}

const getDetailsToBeReportedString = (regime: string): string => {

    switch (regime) {
        case ReportingRegime.Mifir:
        case ReportingRegime.EmirOld:
        case ReportingRegime.Refit:
        case ReportingRegime.MifirCommodityPosition:
        case ReportingRegime.MifirTransparency:
        case ReportingRegime.Sftr:
            return 'Details to be reported (ESMA)';
        case ReportingRegime.AsicOld:
        case ReportingRegime.AsicRewrite:
            return 'Details to be reported (ASIC)';
        case ReportingRegime.MasOld:
        case ReportingRegime.MasRewrite:
            return 'Description of data field (MAS)';
        case ReportingRegime.OscRewrite:
            return 'Detailed Explanation of Data Element (OSC)'; 
        case ReportingRegime.Cat:
            return 'Details to be reported (SEC)';
        case ReportingRegime.SixSecurities:
        case ReportingRegime.SixDerivatives:
            return 'Description (FINMA)';
        default:
            return 'Details to be reported (ESMA)';
    }
}

const getFormatToBeReportedString = (regime: string): string => {

    switch (regime) {
        case ReportingRegime.Mifir:
        case ReportingRegime.EmirOld:
        case ReportingRegime.Refit:
        case ReportingRegime.MifirCb:
        case ReportingRegime.MifirTransparency:
        case ReportingRegime.Sftr:
            return 'Format to be reported (ESMA)';
        case ReportingRegime.AsicOld:
        case ReportingRegime.AsicRewrite:
            return 'Format to be reported (ASIC)';
        case ReportingRegime.MasOld:
        case ReportingRegime.MasRewrite:
            return 'Field Value (MAS)';
        case ReportingRegime.OscRewrite:
            return 'Field Value (OSC)';
        case ReportingRegime.Cat:
            return 'Format to be reported (SEC)';
        case ReportingRegime.SixSecurities:
        case ReportingRegime.SixDerivatives:
            return 'Type (FINMA)';
        default:
            return 'Format to be reported (ESMA)';
    }
}

const getValidationsString = (regime: string): string => {

    switch (regime) {
        case ReportingRegime.Mifir:
        case ReportingRegime.EmirOld:
        case ReportingRegime.Refit:
        case ReportingRegime.MifirCb:
        case ReportingRegime.MifirTransparency:
        case ReportingRegime.Sftr:
            return 'Validations (ESMA)';
        case ReportingRegime.AsicOld:
            return 'Validations (ASIC)';
        case ReportingRegime.AsicRewrite:
            return 'Minimum TR validations (ASIC)'
        case ReportingRegime.MasOld:
        case ReportingRegime.MasRewrite:
            return 'Validations (MAS)';
        case ReportingRegime.OscRewrite:
            return 'Validations (OSC)'
        case ReportingRegime.Cat:
            return 'Validations (SEC)';
        case ReportingRegime.SixSecurities:
        case ReportingRegime.SixDerivatives:
            return 'Validations (FINMA)';
        default:
            return 'Validations (ESMA)';
    }
}

const getFieldNumberString = (regime: string): string => {

    switch (regime) {
        case ReportingRegime.AsicOld:
        case ReportingRegime.AsicRewrite:
            return 'ASIC Field Number';
        default:
            return 'RTS Field Number';
    }
}

const getClassOfSpecifiedDerivativesContractsString = (regime: string): string => {

    switch (regime) {
        case ReportingRegime.AsicRewrite:
            return 'Class of specified derivatives contracts (ASIC)';
        case ReportingRegime.MasRewrite:
            return 'Class of specified derivatives contracts (MAS)';
        default:
            return 'Class of specified derivatives contracts';
    }
}

const getExplanatoryNotesString = (regime: string): string => {

    switch (regime) {
        case ReportingRegime.AsicRewrite:
            return 'Explanatory notes (ASIC)';
        case ReportingRegime.MasRewrite:
            return 'Explanatory notes (MAS)';
        default:
            return 'Explanatory notes';
    }
}

const getConditionString = (regime: string): string => {

    switch (regime) {
        case ReportingRegime.SixSecurities:
            return 'Condition (FINMA)';
        default:
            return '';
    }
}


const shouldShowRegimeSpecificColumn = (regime: string): boolean => {

    switch (regime) {
        case ReportingRegime.MasRewrite:
            return true;
        default:
            return false;
    }
}


const shouldShowCondition = (regime: string): boolean => {

    switch (regime) {
        case ReportingRegime.SixSecurities:
            return true;
        default:
            return false;
    }
}

export { createValidationEsmaTable, getDetailsToBeReportedString, getFormatToBeReportedString, getValidationsString, getFieldNumberString, getConditionString, getClassOfSpecifiedDerivativesContractsString, getExplanatoryNotesString, shouldShowRegimeSpecificColumn, shouldShowCondition } 
